import React from 'react';
import ImageV2 from 'components_v2/common/ImageV2';
import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import s from './NewsletterCard.scss';

const NewsletterSubscriptionPopup = props => {
  const {
    msid,
    heading,
    goodbyeMessage,
    thanksMessage,
    isUnsubscribeMessage,
    subscribeAllPopup,
    infoPopup,
    onCloseCallback = () => {},
  } = props;
  return (
    <ErrorBoundary>
      <PopupPortal usePopupPortal>
        <div className={`${s.overlayWrap} ${s.Newscard}`}>
          <div className={s.overlayContent}>
            <button className={s.closeBtn} onClick={onCloseCallback} />
            {!subscribeAllPopup &&
              !infoPopup && (
                <div className={s.imageWrap}>
                  <div className={s.content}>
                    <ImageV2 msid={msid} width="360" />
                  </div>
                </div>
              )}
            {infoPopup && heading && <h3>{heading}</h3>}
            {!infoPopup && (
              <>
                {isUnsubscribeMessage ? (
                  <h3>
                    We&apos;re sorry to see you go! <i />
                  </h3>
                ) : (
                  <h3 className={s.successMsg}>
                    {' '}
                    <i /> Yay, You&apos;re subscribed!
                  </h3>
                )}
              </>
            )}
            <p>
              {!subscribeAllPopup && (
                <>
                  {isUnsubscribeMessage
                    ? goodbyeMessage ||
                      `Thank you for being part of the ${heading}. If you ever want to rejoin, just know we'll be here with fresh updates and content.`
                    : thanksMessage ||
                      `Welcome to the ${heading} family! Get ready to enjoy our newsletter. We've got some awesome content coming your way.`}
                </>
              )}
              {subscribeAllPopup && (
                <>
                  {isUnsubscribeMessage
                    ? `Thank you for being part of the TOI Newsletters. If you ever want to rejoin, just know we'll be here with fresh updates and content.`
                    : `Welcome to the TOI Newsletters family! Get ready to enjoy our newsletter. We've got some awesome content coming your way.`}
                </>
              )}
            </p>
          </div>
        </div>
      </PopupPortal>
    </ErrorBoundary>
  );
};

export default NewsletterSubscriptionPopup;
